export const NOT_FOUND_PAGE = '/melio/404';
